import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCanInverted$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCanInverted extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0d1a13c479e955be4a38828244a2a522eaabdbe3', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '86dd794cee2a5c904adcf037d997be63815e7670', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8d376a5496187ae30820dc912c5f563f7e7cac1b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16 5c0-1.778-1.977-3-4.5-3S7 3.222 7 5v11.644C7 18.19 9.264 19 11.5 19s4.5-.81 4.5-2.356zm-7.5 6.714V7.238a5.9 5.9 0 0 0 3 .762 6.6 6.6 0 0 0 1.851-.262l-1.91 4.777a5.4 5.4 0 0 1-2.941-.801m3-8.214c1.654 0 3 .673 3 1.5 0 .627-1.141 1.5-3 1.5s-3-.873-3-1.5c0-.827 1.346-1.5 3-1.5m0 14a6.6 6.6 0 0 1-1.932-.266l1.881-4.7h.052a5.44 5.44 0 0 0 3-.8v4.916c-.084.23-1.134.85-3.001.85", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-can-inverted", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-can-inverted"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-can-inverted":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCanInverted$1);
            }
            break;
    } });
}

const CosmosIconCanInverted = CosmosIconCanInverted$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCanInverted, defineCustomElement };
